import {
  AppState,
	BackendService,
	ConfigService,
  MoreConfig,
	StateService
}											from '../../';
import { Component }	from '@angular/core';

declare var doorbell: any;

@Component({
  selector:			'electra-more',
  styleUrls:		[ './more.component.scss' ],
  templateUrl:	'./more.component.html'
})
export class MoreComponent {
	buttons:	any[];
	config:		MoreConfig;
	image			= '';
  state:    AppState;
  selected: string;

  private aboutText = 'About';
  private termsText = 'Terms & Conditions';

  constructor(public backendService: BackendService, public configService: ConfigService, public stateService: StateService) {
		configService.more.subscribe(data => { this.gotConfig(data); });
    stateService.app.subscribe(data => { this.gotState(data); });
	}

	closeClick() {
		this.stateService.state = 'map';
	}

	getButtonStyle(i: number): any {
		return this.configService.mobile ? {
      color: '#000',
			top: (i * 62) + 'px'
		 } : {
      color: this.buttons[i].selected ? this.selected : '#000',
			top: (i * 50 + 35) + 'px'
		 };
	}

	gotConfig(config: MoreConfig) {
		this.config = config
		this.image	= config.image

		this.buttons = []

    this.selected = this.configService.getColor(0, '#fff');

		for (var i = 0, len = config.links.length; i < len; i++) {
			this.buttons.push({
				click:	(i) => { this.stateService.openUrl(this.config.links[i].url) },
				text:		config.links[i].text
			})
		}

		if (config.support) {
			this.buttons.push({
				click:	  () => { this.supportClick() },
        selected: false,
				text:		  'Support & Feedback'
			})
		}

		if (config.terms) {
			this.buttons.push({
				click:	  () => { this.termsClick() },
        selected: false,
				text:		  this.termsText
			})
		}

		if (config.about) {
			this.buttons.push({
				click:	  () => { this.aboutClick() },
        selected: false,
				text:		  this.aboutText
			})
		}

		if (config.login) {
			this.buttons.push({
				click:	  () => { this.loginClick() },
        selected: false,
				text:		  'Professionals Login'
			})
		}
	}

  gotState(state: AppState) {
    this.state = state;

    for (var i = 0, len = this.buttons.length; i < len; i++) {
      if (state.about && this.buttons[i].text === this.aboutText || state.terms && this.buttons[i].text === this.termsText) {
        this.buttons[i].selected = true;
      } else {
        this.buttons[i].selected = false;
      }
    }
  }

	aboutClick() {
    if (this.state.about) {
      this.stateService.state = 'more';
    } else {
		  this.stateService.setState('about', {'label': 'About'});
    }
	}

	loginClick() {
		this.stateService.setState('login', {'label': 'Login'});
	}

	supportClick() {
		doorbell.show();
	}

	termsClick() {
    if (this.state.terms) {
      this.stateService.state = 'more';
    } else {
		  this.stateService.setState('terms', {'label': 'Terms & Conditions'});
    }
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/more/more.component.ts